<template>

<div class="row justify-content-center">

    <div class='col-md-10' v-if='isReady && !projects.length'>
        <div class="alert alert-info">
            Все още нямате създадени проекти. <a href='/add-project'>Можете да добавите нов от тук</a>
        </div>
    </div>

    <div v-for='p in projects' class="col-md-10">
        <div class="container user-project">
            <div class="row">
                <div class="col-12 col-md-5 col-lg-4 p-0 user-project-img">
                    <a :href="p.status == 1 ? '/projects/' + p.id + '/record' : '#'">
                        <img :src="p.image ? p.image : '/resources/images/def-img.jpg'" alt="User project picture">
                    </a>
                </div>
                <div class="col-12 col-md-7 col-lg-8">
                    <div class="row user-project-params">
                        <div class="project-date col-6 col-sm-4 d-flex align-items-center justify-content-center">
                            <span class="icon icon-calendar-start mr-2"></span>
                            <span>
                                <span class="param-label">Старт:</span>
                                <span class="param-val"> {{ dateOnly( p.created_at ) }}</span>
                            </span>
                        </div>
                        <div class="project-date col-6 col-sm-4 d-flex align-items-center justify-content-center">
                            <span class="icon icon-calendar-end mr-2"></span>
                            <span>
                                <span class="param-label">Край:</span>
                                <span class="param-val">
                                    <span v-if='p.finished == 1'>{{ dateOnly( p.finished_at ) }}</span>
                                    <span v-if='p.finished == 0'>-</span>
                                </span>
                            </span>
                        </div>
                        <div class="project-type col-12 col-sm-4">
                            <span class="d-sm-block pr-3 pr-sm-0">
                                <span class="icon icon-flag mr-2"></span>
                                <span class="">{{ p.city }}</span>
                            </span>
                            <span class="d-sm-block">
                                <span class="icon icon-folder mr-2"></span>
                                <span class=""> {{ p.type }} </span>
                            </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 user-project-name">
                            <h3> {{ p.name }} </h3>
                            <p class="user-project-status">
                                <span>
                                    <span class="icon icon-check"></span>
                                    Статус:
                                </span>
                                <span v-if='p.status == 0' class="status-val"> Очаква одобрение </span> 
                                <span v-if='p.status == 1' class="status-val"> Одобрен </span> 
                                <span v-if='p.status == 2' class="status-val"> Отхвърлен </span> 
                            </p>
                            <!-- <p class="user-project-status">
                                <span>
                                    <span class="icon icon-check"></span>
                                    Публикуван:
                                </span>
                                <span v-if='p.published == 0' class="status-val"> Не </span> 
                                <span v-if='p.published == 1' class="status-val"> Да </span> 
                            </p> -->
                            
                        </div>
                    </div>
                    <div class="row user-project-buttons">
                        <div class="col-12 ">
                            <a v-if='p.status == 1' 
                                :href="'/projects/' + p.id + '/record'" class='btn btn-primary mr-0 mr-sm-2'>
                                <span class="icon icon-activity"></span>
                                Досие на проекта
                            </a>
                            <a :href='"/my-projects/" + p.id' class='btn btn-info'>
                                <span class="icon icon-settings"></span>
                                Редакция
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div v-if='isReady' class="col-12 table">
        <table class='table table-striped'>
            <thead>
                <tr>
                    <th>Име</th>
                    <th>Тип</th>
                    <th>Статус</th>
                    <th>Публикуван</th>
                    <th></th>
                </tr>
            </thead>

            <tbody>

                <tr v-for='p in projects'>
                    <td> {{ p.name }} </td>
                    <td> {{ p.type }} </td>
                    <td> 
                        <span v-if='p.status == 0' class='badge badge-warning'> Очаква одобрение </span> 
                        <span v-if='p.status == 1' class='badge badge-success'> Одобрен </span> 
                        <span v-if='p.status == 2' class='badge badge-danger'> Отхвърлен </span> 
                    </td>
                    <td> 
                        <span v-if='p.published == 0' class='badge badge-warning'> Не </span> 
                        <span v-if='p.published == 1' class='badge badge-success'> Да </span> 
                    </td>
                    <td>
                        <a :href='"/my-projects/" + p.id' class='btn btn-info'>
                            Преглед
                        </a>
                    </td>
                </tr>

            </tbody>
        </table>
    </div>
 -->
</div>

</template>

<script>
    export default {

        mounted() {
            
            this.getData();

        },

        created() {
            this.setBcLinks([ { name : 'Моите проекти', url : 'my-projects' } ]);
        },

        data() {
            return {
                
                isReady         : false,
                projects        : [],
                currentProject  : false,
                winnerProject   : false,

            }
        },

        methods : {

            getData() {
                var me = this;

                me.ajax.call("prj:gup", {}, (r) => {

                    if( r.status == 'success' ) {
                        
                        me.projects = r.data;
                        me.isReady  = true;

                    }

                })
            }

        }

    }
</script>
